<template>
  <div class="attribute attribute-custom">
    <div class="custom-control custom-checkbox checkbox">
      <input
        :id="'custom' + attribute.id"
        v-model="attribute.content.checked"
        :true-value="1"
        :false-value="0"
        :disabled="calculateProgress"
        type="checkbox"
        class="custom-control-input">
      <label
        :for="'custom' + attribute.id"
        class="custom-control-label"
        @click="changeAttr">
        {{ attribute.name }}
        + {{ attribute.price }}
        <template v-if="attribute.type == 1">
          руб
        </template>
        <template v-else>
          %
        </template>
      </label>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    props: {
      attribute: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: mapState({
      calculateProgress: state => state.offer.calculateStatus
    }),
    methods: {
      changeAttr: function(){
        this.$store.dispatch('offer/CALCULATE_TRIGGER');
      }
    }
  }

</script>

<style lang="scss" scoped>
  .attribute-custom{
    margin-bottom: 5px;
    font-size: 12px;
  }
  .custom-control-label{
    color: #6E7279;
  }
  .custom-control-input:checked + .custom-control-label{
    color: #2D303A;
  }
  .custom-control-label::before{
    top: 1px
  }
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after{
    top: 1px
  }
</style>